import React, { useEffect, useState } from 'react';
import { FaFilePdf, FaPlus, FaMinus } from 'react-icons/fa';
import './ActasPleno.css';
import { apiFetch } from '../../api/httpClient';

const ActasPleno = () => {
  const [actasPorMes, setActasPorMes] = useState({});
  const [desplegados, setDesplegados] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const fechaActual = new Date();

  const formatearFechaTitulo = (fecha) => {
    return fecha.toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  };

  useEffect(() => {
    apiFetch('/actas')
      .then(response => {
        const agrupadas = {};

        response.forEach(acta => {
          const fecha = acta.fechaSubida ? new Date(acta.fechaSubida) : null;
          if (!fecha) return;

          const mes = fecha.toLocaleString('default', { month: 'long' });
          const clave = `${mes} ${fecha.getFullYear()}`;

          if (!agrupadas[clave]) agrupadas[clave] = [];
          agrupadas[clave].push({ ...acta, fecha });
        });

        setActasPorMes(agrupadas);

        const mesActual = fechaActual.toLocaleString('default', { month: 'long' });
        const añoActual = fechaActual.getFullYear();
        const claveActual = `${mesActual} ${añoActual}`;
        setDesplegados({ [claveActual]: true });
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error al cargar actas:', error);
        setIsLoading(false);
      });
  }, []);

  const toggleDesplegar = (clave) => {
    setDesplegados(prev => ({ ...prev, [clave]: !prev[clave] }));
  };

  const ordenarClavesPorFecha = (claves) => {
    const meses = {
      enero: 0,
      febrero: 1,
      marzo: 2,
      abril: 3,
      mayo: 4,
      junio: 5,
      julio: 6,
      agosto: 7,
      septiembre: 8,
      octubre: 9,
      noviembre: 10,
      diciembre: 11,
    };

    return claves.sort((a, b) => {
      const [mesA, añoA] = a.toLowerCase().split(' ');
      const [mesB, añoB] = b.toLowerCase().split(' ');
      const fechaA = new Date(Number(añoA), meses[mesA]);
      const fechaB = new Date(Number(añoB), meses[mesB]);
      return fechaB - fechaA; // Más reciente primero
    });
  };

  return (
    <section className="actas-pleno">
      <div className="container">
        <h1>Actas de Pleno</h1>
        <p>Consulta las actas agrupadas por mes y año.</p>

        {isLoading ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <p className="loading-text">Cargando actas…</p>
          </div>
        ) : (
          ordenarClavesPorFecha(Object.keys(actasPorMes)).map((clave, index) => (
            <div key={index} className="mes-agrupado">
              <div className="encabezado-mes" onClick={() => toggleDesplegar(clave)}>
                {desplegados[clave] ? <FaMinus /> : <FaPlus />}
                <h2>{clave}</h2>
              </div>

              {desplegados[clave] && (
                <div className="actas-grid">
                  {actasPorMes[clave].map((acta, i) => (
                    <div key={i} className="acta-card">
                      <a href={acta.url} target="_blank" rel="noopener noreferrer">
                        <FaFilePdf className="icono-acta" />
                        <p>{`Acta del ${formatearFechaTitulo(acta.fecha)}`}</p>
                      </a>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </section>
  );
};

export default ActasPleno;
